import React from "react"

export default function(props) {
	return ( 
		<div style={{position: "absolute", top: "1%", fontFamily: "Apercu-Mono", fontSize: "16px", zIndex: 999, width: "100%", textAlign: "center"}}>
			nogrammer
		</div>
	)
}